import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use(
  function (config) {
    const user = cookies.get('user');
    if (user) {
      config.auth = {
        username: user.username,
        password: user.password,
      };
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

API.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default API;



// WEBPACK FOOTER //
// ./src/utils/API.js